export enum PRODUCT_MISC_FIELD_IDS {
  SIZED_QTY = 'sizedQty',
  RECOMMENDED_PRODUCTS = 'recommendedProducts',
  PRODUCT_STATUS = 'ProductStatus',
  LOOK_NAME = 'Look',
  ACTIVE_PRODUCTS = 'isActive',
  CORE_PRODUCTS = 'isCore',
  CLUSTERS = 'Cluster',
  EXCLUDED_PRODUCTS = 'excludedProducts',
  CAPSULE = 'Capsule',
  DROP = 'Drop',
  RETAILSALESPERIOD = 'RetailSalesPeriod'
}
